import {Component, EventEmitter, Inject, OnInit, Output, SecurityContext} from '@angular/core';
import {
  AbstractBffApi,
  HeaderstylesInterface,
  JsonResponseLoggedinfoInterface,
  KeystringValueInterface,
  KeyValueInterface,
  ToolInterface
} from '../../../models/sharedinterface';
import {AuthenticationService} from '../../../security/authentication.service';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalsService} from '../../../shared/services/globals.service';
import {DOCUMENT, Location} from '@angular/common';
import {I18nService} from '../../../shared/services/i18n.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Output('toggleSidebar') toggleSidebar: EventEmitter<any> = new EventEmitter();
  @Output('closeHelpSidebar') closeHelpSidebar: EventEmitter<any> = new EventEmitter();
  @Output('toggleOrderlist') toggleOrderlist: EventEmitter<any> = new EventEmitter();
  @Output('onHeaderReady') onHeaderReady: EventEmitter<any> = new EventEmitter();

  isReady: boolean;

  fullname = '';

  headerstyles: HeaderstylesInterface;
  tools: ToolInterface[];
  languages: KeystringValueInterface[] = [];
  currentlanguage: KeystringValueInterface;

  bffapi: AbstractBffApi;

  bodybackgrounduri: SafeResourceUrl;
  headerlogouri: SafeResourceUrl;

  iframeURL: string;

  iframesource: any;

  currenttool: ToolInterface;

  navbarOpen = false;

  userroles: string[];

  userinfos: any; // need to know if profile is hidden or not

  constructor(
    private authservice: AuthenticationService,
    private apifactory: ApiFactoryService,
    private router: Router,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private shareddata: ShareddataService,
    private globalsservice: GlobalsService,
    private location: Location,
    public i18n: I18nService,
    @Inject(DOCUMENT) private document: Document
  ) {

    // Set default values
    this.headerstyles = {
      headerheight: '100px',
      headerbackgroundcolor: '#ffffff',
      headerlogouri: '',
      headertextcolorclassname: ''
    };

    this.languages = [];
    this.currentlanguage = {key: '', value: ''};

    this.bffapi = this.apifactory.createBffApi();

    this.shareddata.currentiframeURL.subscribe((url) => {
      this.iframesource = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    });
    this.shareddata.currenttool$.subscribe((data) => {
      this.currenttool = data;
    });
    this.shareddata.userroles$.subscribe((data) => {
      this.userroles = data;
    });
  }


  isAmongRoles(specificroles: string[] = []) {
    // The user roles comes from shared data
    // This component subscribes for any user roles change
    const userroles = this.userroles;
    if (userroles.length === 0 || specificroles.length === 0) {
      return false;
    } // if

    // Find intersection
    for (const item of specificroles) {
      if (userroles.indexOf(item) !== -1) {
        return true;
      } // if
    } // for
    return false;
  } // isAmongRoles


  ngOnInit(): void {
    this.shareddata.currentiframeURL.subscribe(lng => this.iframeURL = lng);

    this.shareddata.currentlanguage$.subscribe(lng => this.currentlanguage = lng);

    const query = this.bffapi.getloggedinfo(this.currentlanguage.key);
    query.subscribe((response: JsonResponseLoggedinfoInterface) => {
      const data = response.results;

      this.userinfos = data.userinfo;
      this.shareddata.setMandantLabel(data.userinfo.mandantLabel);
      this.headerstyles = data.headerstyles;
      this.fullname = [data.userinfo.first_name, data.userinfo.last_name].join(' ');

      if (data.additionalCSS) {
        this.injectStyles(data.additionalCSS);
      }

      // Create local language list from http result
      for (const lng of data.languages) {
        this.languages.push(this.globalsservice.getLanguage(lng.key));
      } // for

      this.tools = data.tools;

      this.shareddata.setUserTools(this.tools);

      if (data.headerstyles.headerlogouri) {
        // let logoimg = this.bffapi.getAssets(data.headerstyles.headerlogouri);
        // this.headerlogouri = logoimg;
        this.headerlogouri = data.headerstyles.headerlogouri;
      } // if

      if (data.bodystyles.bodybackgrounduri) {
        // let bodyimg = this.bffapi.getAssets(data.bodystyles.bodybackgrounduri);
        // this.bodybackgrounduri = bodyimg;
        // this.bodybackgrounduri = data.bodystyles.bodybackgrounduri;
        this.shareddata.setBackgroundstyle('url(' + data.bodystyles.bodybackgrounduri + ')');
      } // if

      // Set initially user roles here.
      this.shareddata.setUserroles(data.userinfo.roles);

      this.shareddata.setMandanttitle(data.headerstyles.mandanttitle);

      this.shareddata.setNewsPosition(data.newsPosition);

      this.isReady = true;
      this.onHeaderReady.emit();
    });
  } // ngOnInit

  compareFn(c1: KeyValueInterface, c2: KeyValueInterface): boolean {
    if (c1 && c2) {
      return (c1.key === c2.key);
    }
    return false;
  }

  compareFnKeystring(c1: KeystringValueInterface, c2: KeystringValueInterface): boolean {
    if (c1 && c2) {
      return (c1.key === c2.key);
    }
    return false;
  }

  toggleToolbar() {
    this.navbarOpen = !this.navbarOpen;

    // Adjust global tool height
    this.closeHelpSidebar.emit();
  }

  toggleHelp() {
    if (this.navbarOpen) {
      this.navbarOpen = false;
    }
    this.toggleSidebar.emit();
  }

  toggleOrderList() {
    this.toggleOrderlist.emit();
  }

  onLogout() {
    this.bffapi.logout().subscribe((data) => {
      this.authservice.logout();
    }, error => {
      this.authservice.logout();
    });
  }

  getPortalToolPath(languagekey: string, toolid: number, toolkeyword: string) {
    return ['/' + languagekey + '/ext/' + toolid + '/' + toolkeyword];
  } // getPortalToolPath

  getHelpPath(languagekey: string) {
    return ['/' + languagekey + '/help'];
  } // getHelpPath

  lnginterfacechange(language: KeystringValueInterface) {
    this.shareddata.setCurrentlanguage(language);

    // reloads help data
    const languagekey = this.shareddata.getCurrentlanguage().key;
    const query = this.bffapi.gethelp(languagekey);
    query.subscribe((response) => {
      this.shareddata.setSharedhelpdata(response.results);
    });

    // reloads header link name
    this.bffapi.getToolkeywordTranslation(languagekey)
      .subscribe((response) => {
        this.tools = response.results;
      });

    const pathstructure = this.route.children[0].routeConfig.path;

    switch (pathstructure) {
      case '':
        // No url change here -> directly change data here
        // const query = this.bffapi.getmandantnews2(this.currentlanguage.key);
        // query.subscribe( (data) => {
        //   this.shareddata.setCurrentNews(data.results);
        // });

        break;

      // case this.globalsservice.getHelpPathStructure():
      // Url change. see route guard
      //  this.router.navigate( this.getHelpPath(this.currentlanguage.key) );
      //  break;

      case 'admin':
        // No url change here -> directly change data in admin children here if necessary
        // this.router.navigate( ['admin'] );
        break;

      case 'profil':
        // No url change here -> directly change data in admin children here if necessary
        this.router.navigate(['profil']);
        // No url change here -> directly change data here
        const editprofilviewinterface = this.bffapi.geteditprofilviewinterface(this.currentlanguage.key);
        editprofilviewinterface.subscribe((data) => {
          this.shareddata.setEditprofilviewinterface(data.results);
        });
        break;

      case this.globalsservice.getToolPathStructure():
        // The url changes here
        const toolid = this.route.children[0].snapshot.params.toolid;
        const toolkey = this.route.children[0].snapshot.params.toolkey;

        this.router.navigate(this.getPortalToolPath(this.currentlanguage.key, parseInt(toolid), toolkey));
        break;
    } // switch
  } // lnginterfacechange

  getToolLabel(tool) {
    if (tool.toolenvname !== null && this.isAmongRoles(['ROLE_ADMIN']) || tool.toolenvname !== 'prod') {
      return `${tool.toolkeywordtranslation} (${tool.toolenvname})`;
    } else {
      return `${tool.toolkeywordtranslation}`;
    }
  }

  injectStyles(additionalCSS: string) {
    additionalCSS = this.sanitizer.sanitize(SecurityContext.STYLE, additionalCSS);
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('style');
    style.type = 'text/css';
    style.appendChild(this.document.createTextNode(additionalCSS));
    head.appendChild(style);
  }
}
